module.exports = __webpack_public_path__ + "static/vision-2c1698fa6c4b8b453a7a055e79a5e337.png";